import { Box, BoxProps } from '@palmetto/palmetto-components';
import cx from 'classnames';

export const SkeletonBox = (props: BoxProps): React.JSX.Element => {
  const { className, ...restProps } = props;
  return (
    <Box className={cx('skeletonBox', className)} radius="md" display="block" background="tertiary" {...restProps} />
  );
};
